import { r as y } from "./lit-element-8JrrHldg.js";
import { n as v } from "./property-4FoNj0Pi.js";
var d = Object.defineProperty, P = Object.defineProperties, O = Object.getOwnPropertyDescriptor, b = Object.getOwnPropertyDescriptors, p = Object.getOwnPropertySymbols, g = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable, c = (r, e) => (e = Symbol[r]) ? e : Symbol.for("Symbol." + r), h = (r, e, t) => e in r ? d(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, m = (r, e) => {
  for (var t in e || (e = {}))
    g.call(e, t) && h(r, t, e[t]);
  if (p)
    for (var t of p(e))
      E.call(e, t) && h(r, t, e[t]);
  return r;
}, I = (r, e) => P(r, b(e)), u = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? O(e, t) : e, a = r.length - 1, n; a >= 0; a--)
    (n = r[a]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && d(e, t, i), i;
}, _ = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
}, S = (r, e, t) => (_(r, e, "read from private field"), e.get(r)), x = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, C = (r, e, t, s) => (_(r, e, "write to private field"), e.set(r, t), t), j = function(r, e) {
  this[0] = r, this[1] = e;
}, $ = (r) => {
  var e = r[c("asyncIterator")], t = !1, s, i = {};
  return e == null ? (e = r[c("iterator")](), s = (a) => i[a] = (n) => e[a](n)) : (e = e.call(r), s = (a) => i[a] = (n) => {
    if (t) {
      if (t = !1, a === "throw")
        throw n;
      return n;
    }
    return t = !0, {
      done: !1,
      value: new j(new Promise((w) => {
        var f = e[a](n);
        if (!(f instanceof Object))
          throw TypeError("Object expected");
        w(f);
      }), 1)
    };
  }), i[c("iterator")] = () => i, s("next"), "throw" in e ? s("throw") : i.throw = (a) => {
    throw a;
  }, "return" in e && s("return"), i;
}, o, l = class extends y {
  constructor() {
    super(), x(this, o, !1), this.initialReflectedProperties = /* @__PURE__ */ new Map(), Object.entries(this.constructor.dependencies).forEach(([r, e]) => {
      this.constructor.define(r, e);
    });
  }
  emit(r, e) {
    const t = new CustomEvent(r, m({
      bubbles: !0,
      cancelable: !1,
      composed: !0,
      detail: {}
    }, e));
    return this.dispatchEvent(t), t;
  }
  /* eslint-enable */
  static define(r, e = this, t = {}) {
    const s = customElements.get(r);
    if (!s) {
      try {
        customElements.define(r, e, t);
      } catch {
        customElements.define(r, class extends e {
        }, t);
      }
      return;
    }
    let i = " (unknown version)", a = i;
    "version" in e && e.version && (i = " v" + e.version), "version" in s && s.version && (a = " v" + s.version), !(i && a && i === a) && console.warn(
      `Attempted to register <${r}>${i}, but <${r}>${a} has already been registered.`
    );
  }
  attributeChangedCallback(r, e, t) {
    S(this, o) || (this.constructor.elementProperties.forEach(
      (s, i) => {
        s.reflect && this[i] != null && this.initialReflectedProperties.set(i, this[i]);
      }
    ), C(this, o, !0)), super.attributeChangedCallback(r, e, t);
  }
  willUpdate(r) {
    super.willUpdate(r), this.initialReflectedProperties.forEach((e, t) => {
      r.has(t) && this[t] == null && (this[t] = e);
    });
  }
};
o = /* @__PURE__ */ new WeakMap();
l.version = "2.18.0";
l.dependencies = {};
u([
  v()
], l.prototype, "dir", 2);
u([
  v()
], l.prototype, "lang", 2);
export {
  l as S,
  m as _,
  u as a,
  I as b,
  $ as c
};
